import { useSelector } from "react-redux";
import { convertFromUTCToGivenTimezone, convertUtcStringFormat } from "../../../../../utils/methods/dateTime";
import { reducerPaths } from "../../../../../app/reducerPaths";
import { exportAuctionTimeInMins, localAuction, localAuctionTimeInMins } from "src/utils/constants/auction";

const useGetLiveAuctionRemainingSeconds = () => {

  const auth = useSelector(store => store[reducerPaths.auth]);

  const getLiveAuctionRemainingSeconds = (car) => {
    let liveAuctionDateTime, liveAuctionEndDate, liveAuctionRemainingSeconds;
  
    liveAuctionDateTime = convertFromUTCToGivenTimezone({
      dateStr: convertUtcStringFormat(car?.Live_Auction_DateTime),
      timezone: auth?.timezone
    });
  
    liveAuctionEndDate = new Date(liveAuctionDateTime);
    liveAuctionEndDate.setMinutes(liveAuctionEndDate.getMinutes() + (
      car?.auction_type === localAuction ? localAuctionTimeInMins : exportAuctionTimeInMins
    ));
  
    liveAuctionRemainingSeconds = Math.floor((liveAuctionEndDate.getTime() - new Date().getTime()) > 1000 ?
      (liveAuctionEndDate.getTime() - new Date().getTime()) / (1000) :
      0);
  
    return liveAuctionRemainingSeconds;
  };

  return {
    getLiveAuctionRemainingSeconds
  };
};

export {
  useGetLiveAuctionRemainingSeconds
};